import React, { useContext, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import api from "../services/api";
import { DollarContext } from "../contexts/DollarContext";
import { formatarValor } from "./OrderTable";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const PaymentChart = () => {
  const [payments, setPayments] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPaymentsAndTaxes = async () => {
      try {
        setIsLoading(true);
        const [paymentsResponse, taxesResponse] = await Promise.all([
          api.get("/payments-by-period"),
          api.get("/get-order-load-taxes-by-period"),
        ]);
        setPayments(paymentsResponse.data);
        setTaxes(taxesResponse.data);

        console.log("taxes response: ", JSON.stringify(taxesResponse.data));
      } catch (error) {
        console.error("Erro ao obter pagamentos por período: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPaymentsAndTaxes();
  }, []);

  if (isLoading) return;

  const data = payments.map((payment) =>
    payment.totalAmount._sum.payment_amount
      ? parseFloat(payment.totalAmount._sum.payment_amount * dollarInFloat)
      : 0
  );

  const chartData = {
    labels: [
      [`0 - 15 DIAS`, formatarValor(data[0]?.toFixed(2))],
      [`15 - 30 DIAS`, formatarValor(data[1]?.toFixed(2))],
      [`30 - 45 DIAS`, formatarValor(data[2]?.toFixed(2))],
      [`45 - 60 DIAS`, formatarValor(data[3]?.toFixed(2))],
      [`60 - 90 DIAS`, formatarValor(data[4]?.toFixed(2))],
      [`+ 90 DIAS`, formatarValor(data[5]?.toFixed(2))],
    ],

    datasets: [
      {
        label: "Valor total",
        data: data,
        fill: false,
        backgroundColor: "orange",
        borderColor: "orange",
        tension: 0.4,
        borderWidth: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `R$ ${value.toLocaleString()}`,
          font: {
            size: 14,
            weight: "bold",
          },
          color: "#000",
        },
      },
      x: {
        ticks: {
          font: {
            size: 16,
          },
          color: "#000",
        },
      },
    },
  };

  return (
    <section className="flex justify-center">
      <div className="w-[1000px] h-[700px]">
        <Line data={chartData} options={options} />
      </div>
    </section>
  );
};

export default PaymentChart;
